import { render, staticRenderFns } from "./NewIdChartStackedColumn.vue?vue&type=template&id=024a2e58"
import script from "./NewIdChartStackedColumn.vue?vue&type=script&lang=js"
export * from "./NewIdChartStackedColumn.vue?vue&type=script&lang=js"
import style0 from "./NewIdChartStackedColumn.vue?vue&type=style&index=0&id=024a2e58&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports